import React from "react";
import { Container, Row } from "react-bootstrap";
import Slider from "react-slick";
import RamTempalImage from "../assets/images/ramtemp.jpg";
import SaryuRiver from "../assets/images/SaryuRiver.jpg";
const HomeSlider = () => {
  var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
  };
  return (
    <section className="home-slider">
      <Container fluid className="p-0 m-0">
        <Slider {...settings}>
          <div className="slider-sec">
            <img src="/assets/images/slider2.webp" alt="" />
          </div>
          <div className="slider-sec">
            <img
              src="https://static.punjabkesari.in/multimedia/08_33_115070084tulsidas2-new.jpg"
              alt=""
            />
          </div>
          <div className="slider-sec">
            <img
              src="https://t4.ftcdn.net/jpg/06/68/18/97/240_F_668189711_Esn6zh9PEetE727cyIc9U34NjQOS1b35.jpg"
              alt=""
            />
          </div>
          <div className="slider-sec">
            <img
              src={
                "https://t4.ftcdn.net/jpg/01/90/32/71/240_F_190327104_SXILvpLjf8VaKEaj89csoqp5nyJkSukk.jpg"
              }
              alt=""
            />
          </div>
          <div className="slider-sec">
            <img src={SaryuRiver} alt="" />
          </div>
          <div className="slider-sec">
            <img
              src={
                "https://t4.ftcdn.net/jpg/03/51/54/87/240_F_351548701_ygYDY2Qj1cFm74sN7GibLdGVQyG7u7Mi.jpg"
              }
              alt=""
            />
          </div>
          <div className="slider-sec">
            <img
              src={
                "https://t3.ftcdn.net/jpg/10/24/42/00/240_F_1024420087_TrgUFDHvdzNNvBJ2e8WBoSuTFvAzjyn8.jpg"
              }
              alt=""
            />
          </div>
        </Slider>
      </Container>
    </section>
  );
};

export default HomeSlider;
